/*
 * Blog index page
 * Test endpoint like:
 * http://cloroxpro.localhost/wp-json/wp/v2/blog/
 *
 */
/* global wp MutationObserver */
/* eslint-disable no-underscore-dangle */

import QueryStringHelper from '../helpers/query-string-helper';
import blogItem from '../templates/blog-result-item.hbs';

export default class blogArchive {
    constructor() {
        console.info('Blog Archive Page');
        this.ssLoaded = false;

        // Paginates the current query for its `data-type`
        this.moreButtons = document.querySelectorAll('.js-blog-more');

        // Filters/sorts results for its `data-type`
        this.filters = document.querySelectorAll('select.js-blog-filter, select.js-blog-sort');

        // Loading spinner
        this.loadingElement = document.querySelector('.loading-container');

        // Get topic from URL
        this.topicFromUrl = QueryStringHelper.get('topic');

        if (this.topicFromUrl) {
            $('.js-blog-filter').find('option').removeAttr('selected');
            $(`.js-blog-filter option[value="${this.topicFromUrl}"]`).attr('selected', 'selected');
        }

        // This number should equal `posts_per_page` defined in archive-news.php
        this.offset = 5;
        this.restURL = '/wp-json/wp/v2/';
        wp.api.loadPromise.done(() => {
            this.state = {
                types: {
                    blog: {
                        collection: new wp.api.collections.Blog(),
                        query: {
                            data: {
                                _embed: 1,
                                per_page: this.offset,
                                lang: Electro.currentLanguage,
                                filter: {
                                    cp_term_topic: '',
                                },
                            },
                        },
                    },
                },
            };
            window.state = this.state;

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', this.initState);
            } else {
                // `DOMContentLoaded` already fired
                this.initState();
            }
        });
    }

    initState() {
        Object.keys(window.state.types).forEach((type) => {
            this.refetch(type);
        });

        // this.initTabs();
        this.initListeners();

        // Don't run the init method until slim select has loaded.
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.target.getAttribute('style') && this.ssLoaded === false) {
                    this.ssLoaded = true;
                    this.initPlaceholders();
                    observer.disconnect();
                }
            });
        });
        // pass in the target node, as well as the observer options
        observer.observe(document.querySelector('.slim-select'), { attributes: true });
    }

    initListeners() {
        this.moreButtons.forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                event.target.setAttribute('disabled', true);

                // `data-type` of the element must match one of the `state` keys as
                // defined in the constructor
                const { type } = event.target.dataset;

                this.paginate(type);
            });
        });

        this.filters.forEach((element) => {
            element.addEventListener('change', (event) => {
                const { type } = event.target.dataset;
                this.refetch(type);
            });
        });
    }

    /**
     * Formulate a REST query object based on state of control elements.
     * Does not support multiple filters. Passing an array of objects for the
     * query.data.fiter does not work.
     * @returns {Object} - query parameters to pass to a collection fetch.
     */
    makeQuery(type) {
        const { query } = window.state.types[type] || this.state.types[type];

        this.filters.forEach((element) => {
            const { dataset, value } = element;
            if (dataset.type === type) {
                if (dataset.function === 'filter') {
                    query.data.filter.cp_term_topic = value;
                }
            }
        });
        return query;
    }

    /**
     * Check state and hide "Show More" pagination element if there are no more
     * pages left
     * @returns {undefined}
     */
    updateShowMore(type) {
        const { collection } = this.state.types[type];
        const buttons = document.querySelectorAll('.js-blog-more');

        if (collection.hasMore()) {
            buttons.forEach((button) => {
                button.classList.remove('hidden');
                button.removeAttribute('disabled');
            });
        } else {
            buttons.forEach((button) => {
                button.classList.add('hidden');
                button.setAttribute('disabled', true);
            });
        }
    }

    /**
     * Add an array of JSON post objects to the DOM.
     * Assume that target element is a <ul> inside of an element with ID equal to
     * `type`
     * @returns {undefined}
     */
    renderPosts(posts) {
        const $container = $('#blog-list ul');
        let finalDate = '';

        posts.forEach((post) => {
            const date = new Date(post.acf.start_time ? post.acf.start_time : post.date);
            const day = date.getDate();
            const year = date.getFullYear();

            // is it a french page?
            const pathArray = window.location.pathname.split('/');
            const secondLevelLocation = pathArray[1];
            if (secondLevelLocation == 'fr') {
                const month = date.toLocaleString('fr-CA', { month: 'long' });
                finalDate = `${day} ${month} ${year}`;
            } else {
                const month = date.toLocaleString('en-us', { month: 'long' });
                finalDate = `${month} ${day}, ${year}`;
            }

            let embeddedTerms = [];

            if (post._embedded) {
                embeddedTerms = 'wp:term' in post._embedded ? post._embedded['wp:term'] : [];
            }

            const termObjects = {};
            $.each(embeddedTerms[0], (key, value) => {
                termObjects[value.id] = value;
            });

            const getTerms = (taxonomy, postObj, termsObj) => postObj[taxonomy].map((termId) => termsObj[termId]);

            const authors = getTerms('cp_term_author', post, termObjects);
            let author = {
                name: '',
                acf: {
                    title: '',
                    company: '',
                },
            };

            if (typeof authors[0] !== 'undefined') {
                [author] = authors;
            }

            let thumbnail;
            if (post._embedded) {
                if (typeof (post._embedded && post._embedded['wp:featuredmedia']) !== 'undefined') {
                    thumbnail = post._embedded['wp:featuredmedia']['0'];
                }
            }

            const topics = getTerms('cp_term_topic', post, termObjects);
            const blogData = {
                link: post.link,
                translatedDate: finalDate,
                title: post.title.rendered,
                author: author.name,
                author_title: author.acf.title,
                author_company: author.acf.company,
                excerpt: post.excerpt.rendered,
                topics,
                thumbnail,
            };

            $container.append(blogItem(blogData));
        });
    }

    /**
     * Fetch next pagination page and call render method.
     * @returns {undefined}
     */
    async paginate(type) {
        const moreElement = document.querySelector('#blog-list .js-blog-more');
        const { collection } = this.state.types[type];

        collection
            .more()
            .then((response) => response)
            .then((data) => {
                if (data) {
                    this.renderPosts(data, type);
                    this.updateShowMore(type);
                } else {
                    throw new Error('Response is empty');
                }
            })
            .catch((error) => {
                console.error(error);
                moreElement.classList.add('hide');
                moreElement.parentNode.append('Oops, something went wrong. Please try again.');
            });
    }

    /**
     * Reset results markup with page 1 of current query from state.
     * @returns {undefined}
     */
    refetch(type) {
        const container = document.querySelector('#blog-list ul');

        while (container.lastChild) {
            container.removeChild(container.lastChild);
        }

        const moreElement = document.querySelector('#blog-list .js-blog-more');
        moreElement.classList.add('hidden');
        this.loadingElement.classList.remove('hide');

        const { collection } = this.state.types[type];
        const query = this.makeQuery(type);

        collection
            .fetch(query)
            .then((response) => response)
            .then((data) => {
                if (data) {
                    this.renderPosts(data, type);
                    this.loadingElement.classList.add('hide');
                    this.updateShowMore(type);
                } else {
                    throw new Error('Response is empty');
                }
            })
            .catch((error) => {
                console.error(error);
                moreElement.classList.add('hide');
                moreElement.parentNode.append('Oops, something went wrong. Please try again.');
            })
            // This acts like a `.finally`, which is currently "not a function" in
            // Chrome
            .then(() => this.loadingElement.classList.add('hide'));
    }

    initPlaceholders() {
        const holders = document.querySelectorAll('option[data-placeholder]');
        if (holders.length) {
            holders.forEach((holder) => {
                const span = document.createElement('span');
                span.classList.add('placeholder');
                span.innerHTML = holder.innerHTML;

                const container = holder.parentNode.parentNode.querySelector('.ss-single-selected');
                container.prepend(span);
            });
        }
    }
}
